import { Deserializable } from './deserializable.model';

export class Version implements Deserializable<any, Version> {
  constructor(public id?: string, public product?: string, public minimumVersion?: string) {}

  deserialize(input: any): Version {
    if (input == null) {
      return null;
    }

    this.id = input['id'];
    this.product = input['product'];
    this.minimumVersion = input['minimumVersion'];

    return this;
  }
}
